import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { map,Observable } from 'rxjs';

import { environment } from '@env/environment';

import { Account, AccountPermissions } from '@personal-area/global/accounts/models';
import { FixRateService } from '@personal-area/global/accounts/services';
import { Role } from '@personal-area/global/users/models';
import { UserFacade } from '@personal-area/global/users/services';

import { getAccountType } from '../../pipes/account-type.pipe';

@Component({
    selector: 'global-account-viewer-overview',
    templateUrl: './account-viewer-overview.component.html',
    styleUrls: ['./account-viewer-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AccountViewerOverviewComponent implements OnChanges {
  @Input() account!: Account;

  public isCredentialsVisible = false;
  public isFixRateVisible = false;
  public isSwapFreeVisible = false;
  public swapFreeLabel$: Observable<string>;

  constructor(private _fixRateService: FixRateService, userFacade: UserFacade) {
    this.swapFreeLabel$ = userFacade.user$.pipe(
      map(({ country }) =>
        environment.islamicCountries.includes(country)
          ? 'account.label.islamic'
          : 'account.label.swapfree'
      )
    );
  }

  public get fixedRate(): number {
    return this._fixRateService.getCurrencyRateByCountry();
  }

  public get fixRateCurrency(): string {
    return this._fixRateService.getLocalCurrencyByCountry();
  }

  public ngOnChanges(changes: SimpleChanges) {
    const type = getAccountType(this.account);

    this.isCredentialsVisible = this.account.type === Role.Trader
      && type !== 'archived';
    this.isFixRateVisible = this.account.isFixRate
      && this.account.type === Role.Trader
      && type !== 'promo';
    this.isSwapFreeVisible = this.account.actions.includes(AccountPermissions.swapFree);
  }
}
